import * as React from 'react';

export const brFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_489)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#00953E'
            />
            <mask
                id='mask0_1_489'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_489)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14 2.66666L24 10L14 17.3333L4 10'
                    fill='#FFCC00'
                />
                <path
                    d='M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 9.99999C18.6667 7.42267 16.5773 5.33333 14 5.33333C11.4227 5.33333 9.33333 7.42267 9.33333 9.99999C9.33333 12.5773 11.4227 14.6667 14 14.6667Z'
                    fill='#2C2182'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12 12V13.3333H13.3333V12H12ZM14.6667 12V13.3333H16V12H14.6667Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M10.6667 8C10.6667 8 13.6853 8.53333 15.8613 9.464L18.6667 10.6667'
                    fill='#F1F5F9'
                />
                <path
                    d='M10.6667 8C10.6667 8 13.6853 8.53333 15.8613 9.464L18.6667 10.6667'
                    stroke='#F1F5F9'
                    strokeWidth='1.33333'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_489'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
